// Licence and trial dates are INSTANTS (TGCLOUD-1844): trialEndsAt, lockAt,
// validUntil. Read them with toLocalDateFromInstant — never toLocalDate, which
// reads an "…Z" string by its UTC components and shows the wrong day at a
// positive offset. See CLAUDE.md "Dates": pick the reader by the WRITER.

import React from 'react';
import useDateFormatter from 'src/hooks/useDateFormatter';
import { toLocalDateFromInstant } from 'src/util/partialDate';

export function useInstantFormatter() {
  const fmtDate = useDateFormatter();
  return React.useCallback(
    (value) => (value ? fmtDate(toLocalDateFromInstant(value)) : ''),
    [fmtDate]
  );
}

/**
 * The END of the local calendar day the admin picked, as an ISO instant.
 * "Extend to 30 November" means through the whole of 30 November where the
 * admin is, not UTC midnight at its start (which is still 29 November in
 * every negative-offset zone).
 *
 * @param {Date} pickedLocalDate  a DatePicker value (local midnight)
 */
export function endOfLocalDayIso(pickedLocalDate) {
  if (
    !(pickedLocalDate instanceof Date) ||
    Number.isNaN(pickedLocalDate.getTime())
  )
    return null;
  const d = new Date(
    pickedLocalDate.getFullYear(),
    pickedLocalDate.getMonth(),
    pickedLocalDate.getDate(),
    23,
    59,
    59,
    999
  );
  return d.toISOString();
}
